import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import signalRHelper from "../../../utils/signalRHelper";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import TrackSummary from "./trackSummary";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";
import TrackLog from "./trackLog";
import RealTimeTemperature from "./realTImeTemperature";
import RealTimeSpeed from "./realTimeSpeed";
import { utcToDate } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { getValidTemperature } from "../../../utils/temperature";
import moment from "moment";
import { Button } from "react-bootstrap";
import Select from "react-select";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { setErrorMessage, setHeaderVisible, setReportAssetId, setReportCalendatDate, setReportAssetName, setReportGroupId } from "../../../reducers/actions";
import { connect } from "react-redux";
import GridLoader from "react-spinners/GridLoader";
import queryString from "query-string";

import RealMap from "../../maps/realMap";

const REPORT_FILTERING_STORAGE_KEY = "reportUseFiltering";
const TRACK_MAP_SCROLL_LOCK_STORAGE_KEY = "trackMapScrollLock";

const getSavedReportFilteringState = () => {
  const savedValue = localStorage.getItem(REPORT_FILTERING_STORAGE_KEY);
  return savedValue === null ? true : savedValue !== "false";
};

class Track extends Component {

  constructor(props) {
    super(props);
    this.state = {
      trackSelection: true,
      assetNameTable: "",
      realTimeData: [],
      trackDataTotal: [],
      sensorAGraph: [],
      sensorBGraph: [],
      speedGraph: [],
      showContent: false,
      errorLoader: false,
      errorMessage: "",
      assetName: "",
      assetId: "",
      assetPlaceholder: "Select Asset",
      assetCustomerName: "",
      assetGeneralName: "",
      groupDetails: [],
      groupId: "",
      groupCustomerName: "",
      groupGeneralName: "",
      AssetList: [],
      assetLoader: false,
      isLoading: false,
      reportDetails: "",
      reportLoader: false,
      selectedDate: moment().format("YYYY-MM-DD"),
      utcObj: {},
      speedObj: {},
      mapChange: "",
      singleTruckZoom: "",
      followTruckPosition: "",
      followSelectedAsset: true,
      loadedReportParams: null,
      isFullScreen: false,
      scrollLockEnabled: localStorage.getItem(TRACK_MAP_SCROLL_LOCK_STORAGE_KEY) !== "false",
      trackTrailPoints: [],
    };
    this.groupId = "";
    this.trackSignalRStarted = false;
  }

  async componentDidMount() {
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", this.handleFullscreenChange);
    const values = queryString.parse(this.props.location.search);
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const urlState = {};

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      urlState.assetName = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetPlaceholder = assetName;
      urlState.assetId = assetId;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }

    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  }

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.setState({ assetLoader: false });
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        assetId: "",
        AssetList: [],
        assetLoader: false,
        showContent: false,
        reportDetails: "",
        realTimeData: [],
        trackDataTotal: [],
      });
      this.props.setReportGroupIdAction("");
      signalRHelper.resetAssetFilter();
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      groupCustomerName: group.customername,
      groupGeneralName: group.groupName,
      assetName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      assetPlaceholder: "Select Asset",
      assetId: "",
      AssetList: [],
      assetLoader: true,
      showContent: false,
      reportDetails: "",
      realTimeData: [],
      trackDataTotal: [],
    });
    this.props.setReportGroupIdAction(group.groupId);
    signalRHelper.resetAssetFilter();
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        showContent: false,
        reportDetails: "",
        realTimeData: [],
        trackDataTotal: [],
      });
      signalRHelper.resetAssetFilter();
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetName: asset.name,
      assetCustomerName: asset.name,
      assetGeneralName: asset.customerName,
      assetPlaceholder: asset.name,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  handleFullScreen = () => {
    const elem = document.getElementById("realMapContainer");
    if (!elem) return;

    if (!this.state.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      return;
    }

    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  handleFullscreenChange = () => {
    const isFullScreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    this.setState({ isFullScreen: !!isFullScreen });
  };

  toggleScrollLock = () => {
    const scrollLockEnabled = !this.state.scrollLockEnabled;
    localStorage.setItem(TRACK_MAP_SCROLL_LOCK_STORAGE_KEY, scrollLockEnabled ? "true" : "false");
    this.setState({ scrollLockEnabled });
  };

  setFollowSelectedAsset = (followSelectedAsset) => {
    this.setState({ followSelectedAsset });
  };

  toggleFollowSelectedAsset = () => {
    if (!this.state.assetId) return;

    const followSelectedAsset = !this.state.followSelectedAsset;
    this.setFollowSelectedAsset(followSelectedAsset);

    if (followSelectedAsset) {
      const latestLocation = this.getLiveLocation(this.state.realTimeData[0]);
      if (latestLocation) {
        this.setState({ followTruckPosition: latestLocation });
      }
    }
  };

  handleMapUserMove = () => {
    if (this.state.followSelectedAsset) {
      this.setFollowSelectedAsset(false);
    }
  };

  getQuickReportUrl = (path) => {
    const assetName = this.state.assetName || this.state.assetCustomerName || this.state.assetPlaceholder || "";
    const reportDate = moment().format("YYYY-MM-DD");
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName,
    });

    if (path !== "/Track") {
      params.set("SearchDate", reportDate);
      params.set("assetDate", reportDate);
      params.set("UseFiltering", String(getSavedReportFilteringState()));
    }

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  getLiveLocation = (data) => {
    const message = data && (data.lastMessage || data.message || data);
    const gprmc = message && (message.gPRMC || message.gprmc);
    const lat = gprmc && (gprmc.latitude || gprmc.Latitude || gprmc.lat || gprmc.Lat);
    const lng = gprmc && (gprmc.longitude || gprmc.Longitude || gprmc.lng || gprmc.Lng);

    if (lat === undefined || lat === null || lng === undefined || lng === null) return null;

    return {
      assetId: data.assetId || data.assetID || message.assetID || message.assetId || this.state.assetId,
      name: data.assetName || data.name || message.name || this.state.assetName || this.state.assetCustomerName,
      lat: Number(lat),
      lng: Number(lng),
      heading: gprmc.heading || gprmc.Heading || 0,
      speed: gprmc.speed || gprmc.Speed || 0,
      created: message.created,
      gprs: message.gprsOnline,
      parking: message.iO8,
      colour: message.colour || message.Colour || data.colour || data.Colour || data.groupColour || data.GroupColour || "",
      icon: message.icon || message.Icon || data.icon || data.Icon || data.groupIcon || data.GroupIcon || "",
    };
  };

  appendTrackTrailPoint = (location) => {
    if (!location) return;

    this.setState((state) => {
      const lastPoint = state.trackTrailPoints[state.trackTrailPoints.length - 1];
      if (
        lastPoint &&
        Number(lastPoint.lat).toFixed(6) === Number(location.lat).toFixed(6) &&
        Number(lastPoint.lng).toFixed(6) === Number(location.lng).toFixed(6)
      ) {
        return null;
      }

      return {
        trackTrailPoints: [
          ...state.trackTrailPoints,
          {
            lat: location.lat,
            lng: location.lng,
            created: location.created,
          },
        ],
      };
    });
  };

  handleCreateReport = () => {
    if (!this.state.assetId) {
      this.setState({
        showContent: false,
        reportLoader: false,
        errorLoader: true,
        errorMessage: "Select an asset before starting the Track report.",
      });
      return;
    }

    this.props.setReportAssetIdAction(this.state.assetId);
    this.props.setReportAssetNameAction(this.state.assetName || this.state.assetCustomerName);
    this.props.setReportCalendatDateAction(moment().format("YYYY-MM-DD"));
    this.props.setReportGroupIdAction(this.state.groupId);
    this.updateCurrentReportUrl();
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        groupId: this.state.groupId,
      },
    });

    let url = `${apiHost}/api/Assets/LatesteventByAssetid/${this.state.assetId}`;
    this.setState({
      showContent: true,
      reportLoader: true,
      errorLoader: false,
      errorMessage: "",
      reportDetails: "",
      realTimeData: [],
      trackDataTotal: [],
      sensorAGraph: [],
      sensorBGraph: [],
      speedGraph: [],
      followTruckPosition: "",
      followSelectedAsset: true,
      trackTrailPoints: [],
    });
    this.setTruck(url);

    signalRHelper.setAssetFilter(this.state.assetId);
  };

  setTruck = async (url) => {
    try {
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        let array = [];
        array.push(response.data);
        response.data = array;
        console.log(" response..", response.data);
        this.setState({
          reportDetails: response.data,
          realTimeData: response.data,
          trackDataTotal: response.data,
          reportLoader: false,
          errorLoader: false,
        });

        const location = this.getLiveLocation(response.data[0]);
        this.appendTrackTrailPoint(location);
        if (location && this.state.followSelectedAsset) {
          this.setState({ followTruckPosition: location });
        }

        this.setGraph(response.data);
        this.startTrackSignalR();
      }
    } catch (e) {
      this.setState({ reportLoader: false, errorLoader: true });
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  startTrackSignalR = () => {
    if (this.trackSignalRStarted) return;

    this.trackSignalRStarted = true;
    setTimeout(() => {
      this.handleSignalR();
    }, 0);
  };

  getTruthyFlag = (value) => {
    return value === true || value === 1 || value === "1" || value === "true" || value === "True";
  };

  getCurrentTrackAsset = () => {
    return this.state.trackDataTotal[0] || this.state.realTimeData[0] || {};
  };

  getTrackAssetId = (data) => {
    const message = data && (data.lastMessage || data.message || data);

    return data && (data.assetId || data.AssetId || data.assetID || data.AssetID || (message && (message.assetId || message.AssetId || message.assetID || message.AssetID)));
  };

  getTrackFeatureFlags = () => {
    const asset = this.getCurrentTrackAsset();

    return {
      tempAEnabled: this.getTruthyFlag(asset.tempA !== undefined ? asset.tempA : asset.TempA),
      tempBEnabled: this.getTruthyFlag(asset.tempB !== undefined ? asset.tempB : asset.TempB),
      doorSensorEnabled: this.getTruthyFlag(asset.doorSensor !== undefined ? asset.doorSensor : asset.DoorSensor),
    };
  };

  mergeTrackAssetSettings = (incoming) => {
    const existing = this.getCurrentTrackAsset();
    const tempA = incoming.tempA !== undefined ? incoming.tempA : incoming.TempA !== undefined ? incoming.TempA : existing.tempA !== undefined ? existing.tempA : existing.TempA;
    const tempB = incoming.tempB !== undefined ? incoming.tempB : incoming.TempB !== undefined ? incoming.TempB : existing.tempB !== undefined ? existing.tempB : existing.TempB;
    const doorSensor = incoming.doorSensor !== undefined ? incoming.doorSensor : incoming.DoorSensor !== undefined ? incoming.DoorSensor : existing.doorSensor !== undefined ? existing.doorSensor : existing.DoorSensor;

    return {
      ...incoming,
      assetId: this.getTrackAssetId(incoming) || this.state.assetId,
      tempA,
      TempA: tempA,
      tempB,
      TempB: tempB,
      doorSensor,
      DoorSensor: doorSensor,
    };
  };

  setGraph = (data) => {
    var timeX = [];
    var utcObj = {};
    var speedObj = {};

    var sensorAGraph = [];
    var sensorBGraph = [];
    var speedGraph = [];
    var timeZoneID = localStorage.getItem("timeZoneID");
    data.forEach((single) => {
      if (single.lastMessage !== null) {
        let newtime = moment
          .utc(single.lastMessage.created)
          .tz(timeZoneID)
          .format();
        var timezoneOffset = moment(newtime);
        console.log("time zone offset", timezoneOffset._tzm);
        var timeZoneSeconds = timezoneOffset._tzm;
        var myDate = new Date(single.lastMessage.created);
        var result = myDate.getTime();
        var seconds = timeZoneSeconds * 60 * 1000;

        let value = result + seconds;
        let valueUtc = utcToDate(single.lastMessage.created);
        utcObj[value] = valueUtc;
        let speedValue = single.lastMessage.gPRMC
          ? single.lastMessage.gPRMC.speed
          : null;
        let roundedSpeed = parseFloat(rounding(speedValue));

        speedObj[value] = valueUtc;
        let pointA = getValidTemperature(single.lastMessage.sensorAValue);
        let pointB = getValidTemperature(single.lastMessage.sensorBValue);
        let sensorAPoint = [value, pointA];
        let sensorBPoint = [value, pointB];
        let speedPoint = [value, roundedSpeed];
        if (!timeX.includes(value)) {
          timeX.push(value);
          if (pointA !== null) {
            sensorAGraph.push(sensorAPoint);
          }
          if (pointB !== null) {
            sensorBGraph.push(sensorBPoint);
          }
          speedGraph.push(speedPoint);
        }
      }
    });

    this.setState({ sensorAGraph, utcObj, speedObj, sensorBGraph, speedGraph });
  };

  Comparator = (a, b) => {
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
  };

  getHour = (hour) => {
    var a = hour;
    var b = a.split(":");

    var c = parseFloat(b[0] + "." + b[1]);
    return c;
  };

  async handleSignalR() {
    try {
      this.connection = await signalRHelper.getConnection();
      this.addTransferChartDataListener();
    } catch (e) {
      this.trackSignalRStarted = false;
      console.log("Track SignalR connection failed", e);
    }
  };

  componentWillUnmount() {
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("MSFullscreenChange", this.handleFullscreenChange);
    this.releaseSignalR();
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe('RealTimeMap');
    signalRHelper.unsubscribe('Powercut');
    signalRHelper.unsubscribe('Duress');

    signalRHelper.resetAssetFilter();
    signalRHelper.resetGroupFilter();

    this.connection.off("RealTimeMap");
    this.connection.off("Powercut");
    this.connection.off("Duress");
    this.connection = null;
  }

  addTransferChartDataListener = () => {
    signalRHelper.subscribe('RealTimeMap');
    signalRHelper.subscribe('Powercut');
    signalRHelper.subscribe('Duress');

    this.connection.on("RealTimeMap", (data) => {
      const liveData = this.mergeTrackAssetSettings(data);
      this.data = liveData;

      if (liveData.assetId == this.state.assetId) {
        this.updateMap(JSON.stringify(liveData));

        const trackDataTotal = [...this.state.trackDataTotal];
        trackDataTotal.unshift(liveData);
        const location = this.getLiveLocation(liveData);

        this.setState({
          realTimeData: [liveData],
          trackDataTotal,
          ...(location && this.state.followSelectedAsset ? { followTruckPosition: location } : {}),
        });

        this.appendTrackTrailPoint(location);
        this.setGraph(trackDataTotal);
      }
    });

    this.connection.on("Powercut", (data) => {
      console.log("entry Powercut");
      this.handlePowerCut(data);
    });

    this.connection.on("Duress", (data) => {
      console.log("entry Duress");
      this.handleDuress(data);
    });
  };

  handlePowerCut = (data) => {
    let trackDataTotal = [...this.state.trackDataTotal];
    if (trackDataTotal.length > 0 && trackDataTotal[0].assetId == data.assetId) {
      let powerCut = data;
      trackDataTotal[0].powerCut = powerCut;
      this.setState({ trackDataTotal });
      this.setState({ realTimeData: trackDataTotal });
    }
  };

  handleDuress = (data) => {
    if (this.state.trackDataTotal.length > 0 && this.state.trackDataTotal[0].assetId == data.assetId) {
      let trackDataTotal = [...this.state.trackDataTotal];
      if (trackDataTotal.length > 0 && trackDataTotal[0].assetId == data.assetId) {
        let duress = data;
        trackDataTotal[0].duress = duress;
        this.setState({ trackDataTotal });
      }
    }
  };

  updateMap = (data) => {
    this.setState({ mapChange: data });
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetPlaceholder,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetPlaceholder,
              customerName: this.state.assetGeneralName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "")
      )
    );
    const trackFeatureFlags = this.getTrackFeatureFlags();

    return (
      <Layout>
        <Helmet>
          <title>Track</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page track-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page track-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Track Report</h2>
                  <p>Monitor the selected asset on today&apos;s live track with current metrics, route updates and telemetry.</p>
                </div>
                <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="reportQuickActions">
                  <span className="reportQuickActionsLabel">Quick reports</span>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Replay")}>Replay</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                  <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                </div>
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  <Button className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"} variant="primary" onClick={this.handleCreateReport} size="sm" disabled={!this.state.assetId}>
                    <i className="fa fa-location-arrow"></i>
                    Start Track
                  </Button>
                </div>
              </div>
            </div>
            <div className="reportBody">
              {this.state.showContent ? (
                <React.Fragment>
                  {this.state.reportLoader ? (
                    <div className="loaderLine">
                      <br />{" "}
                      <GridLoader
                        size={7}
                        color={"#222222"}
                        loading={this.state.reportLoader}
                      />
                      <h1> &nbsp;Generating Report</h1>
                      <br />
                    </div>
                  ) : this.state.errorLoader ? (
                    <div className="loaderLine">
                      <h1>{this.state.errorMessage || "Something Went Wrong...!"}</h1>
                    </div>
                  ) : (
                    <React.Fragment>
                      {(this.state.reportDetails != "" && this.state.reportDetails[0].lastMessage) ? (
                        <React.Fragment>
                          <TrackSummary
                            trackDataTotal={this.state.trackDataTotal}
                            tempAEnabled={trackFeatureFlags.tempAEnabled}
                            tempBEnabled={trackFeatureFlags.tempBEnabled}
                            doorSensorEnabled={trackFeatureFlags.doorSensorEnabled}
                          />
                          <div>
                            {" "}
	                            <RealMap
	                              mapChange={this.state.mapChange}
	                              singleTruckZoom={this.state.singleTruckZoom}
                                followTruckPosition={this.state.followTruckPosition}
	                              realTimeData={this.state.realTimeData}
                                selectedAssetId={this.state.assetId}
                                showMapControls
                                headingLabel={this.state.followSelectedAsset ? "Following asset" : "Follow paused"}
                                isFullScreen={this.state.isFullScreen}
                                scrollLockEnabled={this.state.scrollLockEnabled}
                                followSelectedAsset={this.state.followSelectedAsset}
                                trackTrailPoints={this.state.trackTrailPoints}
                                keepFollowOnZoom
                                useHeadingFollowToggle
                                hideClusterControl
                                hideClearControl
                                onFullscreenToggle={this.handleFullScreen}
                                onScrollLockToggle={this.toggleScrollLock}
                                onFollowSelectedToggle={this.toggleFollowSelectedAsset}
                                onUserMove={this.handleMapUserMove}
	                            />
                          </div>

                          {(trackFeatureFlags.tempAEnabled || trackFeatureFlags.tempBEnabled) && (
                            <RealTimeTemperature
                              aData={this.state.sensorAGraph}
                              bData={this.state.sensorBGraph}
                              utcObj={this.state.utcObj}
                              tempAEnabled={trackFeatureFlags.tempAEnabled}
                              tempBEnabled={trackFeatureFlags.tempBEnabled}
                            />
                          )}

                          <RealTimeSpeed
                            sData={this.state.speedGraph}
                            speedObj={this.state.speedObj}
                          />
                          <TrackLog
                            trackDataTotal={this.state.trackDataTotal}
                            tempAEnabled={trackFeatureFlags.tempAEnabled}
                            tempBEnabled={trackFeatureFlags.tempBEnabled}
                            doorSensorEnabled={trackFeatureFlags.doorSensorEnabled}
                          />
                        </React.Fragment>
                      ) : (
                        <AssetInforWarning
                          warningText={true}
                          warningTextMsg="No Data Available"
                        />
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              ) : (
                <AssetInforWarning
                  warningText={true}
                  warningTextMsg="No Data Available"
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
});
const mapDispatchToProps = {
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Track);
